import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: 'CopySchedule',
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      scheduleId: null,
      scheduleType: null,
      copyTo: null,
      teamsSelected: [],
      isLoading: false,
      teams: []
    }
  },
  validations: {
    scheduleId: { required },
    scheduleType: { required },
    copyTo: { required }
  },
  computed: {
    getTitle () {
      return this.$t('work-schedule.copy-schedule');
    },
    canEdit () {
      return !this.isLoading;
    },
    teamOptions () {
      const options = [
        // { value: '*', text: 'Visus' },
        { value: 'none', text: 'Bez komandas' }
      ];
      for (const team of this.teams) {
        options.push({
          value: team.id,
          text: team.name
        });
      }

      return options;
    },
    copyToOptions () {
      const options = [
        { value: 'plan', text: this.$t('work-schedule.copy-to-options.plan') },
        { value: 'view', text: this.$t('work-schedule.copy-to-options.view') },
        { value: 'track', text: this.$t('work-schedule.copy-to-options.track') }
      ];
      return options.filter(obj => obj.value !== this.scheduleType);
    }
  },
  methods: {
    show (scheduleId, type, teams) {
      this.copyTo = null;
      this.scheduleId = this.BasicHelper.cloneObject(scheduleId);
      this.scheduleType = this.BasicHelper.cloneObject(type);
      this.teams = teams;

      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = {
          teams: this.teamsSelected,
          copy_to: this.copyTo
        };
        this.ApiRequest.request('ezuro/schedule/copy/' + this.scheduleId, this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.close();
            this.ApiRequest.displaySuccessDialog(this, null, this.$t('work-schedule.copy-success'));
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
